import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessUserPunchCardListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-business-user-punch-card-list',
  templateUrl: 'business-user-punch-card-list.html',
})
export class BusinessUserPunchCardListPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessUserPunchCardListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-user-punch-card-list/business-user-punch-card-list.ts